<template>
  <base-input :rules="internalRules" :errors="errors">
    <slot />
  </base-input>
</template>

<script>
import validatable from "@/mixins/validatable";

export default {
  mixins: [validatable],
  props: {
    modelValue: [String, Number, Boolean, Array],
  },
  methods: {
    reset() {
      this.isResetting = true;
      this.$emit("update:modelValue", null);
    },
  },
};
</script>
